export const STORE_PREFIX = "deleteModal";
